






































import { Component, Prop, Vue } from "vue-property-decorator";

import SmallText from "@/common/components/atoms/SmallText.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";

import commons from "@/common/store/modules/commons";
import { formatUTCDate } from "@/common/assets/js/utils/dateFormat";

@Component({
  components: {
    SmallText,
    PointNotation,
    TextLabel
  }
})
export default class ExpirationItemPanel extends Vue {
  @Prop({ type: String, required: true }) date!: string;
  @Prop({ type: String, required: true }) detail!: string;
  @Prop({ type: String, required: true }) status!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Number, required: true }) point!: number;
  @Prop({ type: String, required: true }) point_name!: string;

  get customizeColor() {
    return commons?.colorCode;
  }

  get formated_date() {
    return formatUTCDate(this.date);
  }
}
